/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.10.22",
    versionName: "0.8.0-nightly.2026.10.22",
    versionChannel: "nightly",
    buildDate: "2026-10-22T00:14:58.485Z",
    commitHash: "70e372fae4d2033499550a2c6bb12e5e9e87e04e",
};
